import { render, staticRenderFns } from "./DMDashboard.vue?vue&type=template&id=d6a00110&"
import script from "./DMDashboard.vue?vue&type=script&lang=js&"
export * from "./DMDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports